import { render, staticRenderFns } from "./buy3sCloneSuccess.vue?vue&type=template&id=16ecf114&"
import script from "./buy3sCloneSuccess.vue?vue&type=script&lang=js&"
export * from "./buy3sCloneSuccess.vue?vue&type=script&lang=js&"
import style0 from "./buy3sCloneSuccess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports